import React, {PropTypes} from 'react';
import {Field} from 'redux-form';
import MinimalField from 'shared/MinimalField.jsx';

const AdministratorItem = ({
  id,
  email,
  isPrimary,
  editing,
  onSaveClick,
  onCancelClick,
  onRemoveClick
}) => (
editing
? <div className="list-group-item-labeled"
    style={{display: 'inherit'}}>
    <div className="list-group-item-labeled-child">
      <span style={{paddingBottom: '8px'}} />
      <Field
        classString="form-group flex"
        name="tournamentAdministratorEmail"
        type="text"
        component={MinimalField}
        placeholder="Administrator Email"
      >
        <button
          type="button"
          className="btn btn-primary-brand"
          onClick={() => onCancelClick(id, email)}
          >{'Cancel'}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onSaveClick(id, email)}
          >{'Save'}
        </button>
      </Field>
    </div>
  </div>
: <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child">
      <span style={{paddingBottom: '8px'}} />
      <span>{`${email != null ? email.toLowerCase() : '{email unknown}'}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{flexDirection: 'row'}}>
      {!isPrimary
          ? <button className="btn btn-link"
              type="button"
              onClick={() => onRemoveClick(id)}>
              <i className="fa fa-times" /> {'Remove'}</button>
          : null
      }
    </div>
  </div>
);

AdministratorItem.propTypes = {
  id: PropTypes.string,
  isPrimary: PropTypes.bool,
  email: PropTypes.string,
  editing: PropTypes.bool,
  onSaveClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onRemoveClick: PropTypes.func
};

AdministratorItem.defaultProps = {
  isPrimary: false
};

export default AdministratorItem;


// WEBPACK FOOTER //
// ./src/features/tournament/permissions/AdministratorItem.jsx